// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-animation-container.k-animation-container-fixed.k-animation-container-shown.node-name-tooltip {\n  margin-top: -6px;\n  left: 61px !important;\n  max-width: 220px;\n}\n.k-animation-container.k-animation-container-fixed.k-animation-container-shown.node-name-tooltip .k-tooltip {\n  margin-top: 0;\n}", ""]);
// Exports
module.exports = exports;
